import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';
import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import PlusIcon from '@usas/ui-web/components/icons/PlusIcon';


import global from '@usas/ui-web/components/GlobalStyle.module.css';

const NewClubRegistrationLargeGrid = ({ state, registrationRoles, onEdit, onDelete }) => (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
        <thead>
            <tr>
                <th>Staff Role</th>
                <th>Name</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            {state.isArrayLoaded !== true
                ? (
                    <tr>
                        {state.isArrayLoading === true ?
                            <td colSpan="3">Loading...</td>
                            : <td colSpan="3">No Staff Roles</td>
                        }
                    </tr>
                ) : Array.isArray(state.arrayData) && state.arrayData.length > 0
                    ? state.arrayData.map(role => (
                        <tr key={role.roleNum}>
                            <td style={{width: "590px"}}>{role.orgRoleName}</td>
                            <td>{role.name}</td>
                            <td>
                                {role.met === false &&
                                    <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e, role.orgRoleId, role.orgRoleName)}>
                                        <PlusIcon />
                                    </button>
                                }
                                {role.met === true &&
                                    !registrationRoles.find(x => x === role.orgRoleName) &&
                                        <button className={global.IconButtonMargin} type="button" onClick={(e) =>
                                          onDelete(e, role.personOrgRoleDurationId)}>
                                          <DeleteIcon />
                                        </button>
                                      
                                }
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan="3">No Legal Entities</td>
                        </tr>
                    )
            }
        </tbody>
    </table>
);

export default NewClubRegistrationLargeGrid;